import React from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import {
  BUILDING_TYPE_ID,
  FLAT_CATEGORIES,
  SEARCH_RESULT_ROUTES,
  isRentLandingPath
} from '../../../../utils/helpers/constants';
import { capitalizeFirstLetter } from '../../../../utils/helpers/common';
import { selectSearchFormCurrentState } from '../../../../store/selectors';
import Icon from '../../../Icon';
import ArrowRight from '../../../../public/static/images/item/arrow-right.svg';
import FilterIcon from '../../../../public/static/images/new_search/icons/icon-filter.svg';

import {
  InitialSearchBarContainer,
  FiltersContainer,
  FilterWrapper,
  SelectButton,
  TextsContainer,
  SelectText,
  ArrowIcon,
  LocationBarWrapper,
  LocationBar,
  LocationBarText,
  LocationPlaceholder,
  LocationCity,
  FilterButton,
  FilterButtonText,
  SearchButton,
  SearchButtonText
} from './styled';

export const NewSearchBarInitialComponent = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const currentFormState = useSelector(selectSearchFormCurrentState);
  const isHomePage = router.pathname === '/';
  const isSalePage = router.asPath === SEARCH_RESULT_ROUTES.SALE;
  const isRentPage = isRentLandingPath(router.asPath);
  const isItemsAllPage = router.pathname === SEARCH_RESULT_ROUTES.ITEMS_ALL;

  const isHomeOrItemsAllPage = isHomePage || isItemsAllPage;
  const isShowHomeFilters = isSalePage || isRentPage || isHomeOrItemsAllPage;
  const categoryId = currentFormState?.category_id || BUILDING_TYPE_ID.FLAT_ALL;
  const isFlatCategory = FLAT_CATEGORIES.includes(categoryId);

  const categoryLabel = capitalizeFirstLetter(
    t(`pages.current_item.categories.id_${categoryId}`)
  );

  const areaUnits =
    categoryId === BUILDING_TYPE_ID.AREA
      ? t('search.form.units.acres')
      : t('search.form.units.metres');

  return (
    <InitialSearchBarContainer
      $isSearchPage={!isShowHomeFilters}
      $isHomePage={isHomePage}
      data-cy="search-bar-container"
    >
      <FiltersContainer $isShowHomeFilters={isShowHomeFilters}>
        <FilterWrapper $isShowHomeFilters={isShowHomeFilters}>
          <SelectButton $isShowHomeFilters={isShowHomeFilters}>
            <TextsContainer>
              <SelectText $color="primary">{t('search.form.buy')}</SelectText>
            </TextsContainer>
            <ArrowIcon>
              <Icon
                indent={false}
                height={14}
                width={7}
                IconComponent={ArrowRight}
              />
            </ArrowIcon>
          </SelectButton>
        </FilterWrapper>
        <FilterWrapper $isShowHomeFilters={isShowHomeFilters}>
          <SelectButton $isShowHomeFilters={isShowHomeFilters}>
            <TextsContainer>
              <SelectText $color="primary">{categoryLabel}</SelectText>
            </TextsContainer>
            <ArrowIcon>
              <Icon
                indent={false}
                height={14}
                width={7}
                IconComponent={ArrowRight}
              />
            </ArrowIcon>
          </SelectButton>
        </FilterWrapper>

        <FilterWrapper
          $isShowHomeFilters={isShowHomeFilters}
          $hideOnMedium={!isShowHomeFilters}
        >
          <SelectButton $isShowHomeFilters={isShowHomeFilters}>
            <TextsContainer>
              <SelectText>
                {isFlatCategory
                  ? t('search.form.rooms')
                  : `${t('search.form.area')} ${areaUnits}`}
              </SelectText>
            </TextsContainer>
            <ArrowIcon>
              <Icon
                indent={false}
                height={14}
                width={7}
                IconComponent={ArrowRight}
              />
            </ArrowIcon>
          </SelectButton>
        </FilterWrapper>
        <FilterWrapper $isShowHomeFilters={isShowHomeFilters}>
          <SelectButton $isShowHomeFilters={isShowHomeFilters}>
            <TextsContainer>
              <SelectText>{t('new_search.price')}, ₼</SelectText>
            </TextsContainer>
            <ArrowIcon>
              <Icon
                indent={false}
                height={14}
                width={7}
                IconComponent={ArrowRight}
              />
            </ArrowIcon>
          </SelectButton>
        </FilterWrapper>
        <LocationBarWrapper $isShowHomeFilters={isShowHomeFilters}>
          <LocationBar>
            <LocationBarText>
              <LocationPlaceholder>
                {t('search.locations_search.locations_placeholder.all_groups')}
              </LocationPlaceholder>
              <LocationCity tag="body_1">
                {t('search.city_search.baku')}
              </LocationCity>
            </LocationBarText>
          </LocationBar>
        </LocationBarWrapper>
        <FilterButton $isShowHomeFilters={isShowHomeFilters}>
          <Icon
            width={20}
            height={20}
            indent={false}
            IconComponent={FilterIcon}
          />
          <FilterButtonText tag="body_1">
            {t('search.buttons.filters')}
          </FilterButtonText>
        </FilterButton>
      </FiltersContainer>
      <SearchButton>
        <SearchButtonText tag="body_1">
          {t('search.buttons.find')}
        </SearchButtonText>
      </SearchButton>
    </InitialSearchBarContainer>
  );
};
